import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'stripHtml',
    standalone: true
})
export class StripHtmlPipe implements PipeTransform {
    transform(value: unknown, ...args: unknown[]): unknown {
       if (!value) {
            return '';
        }
        // value is a html string
        // this pipe should remove all <hx>, <ul>, <ol>, <li> and <a> tags and text inside them
        // later remove all html tags and leave only text
        let result = value as string;
        result = result.replace(/<h\d>(.*?)<\/h\d>/g, '$1 ');; // remove all <hx> tags and text inside them
        result = result.replace(/<ul>|<\/ul>/g, ''); // remove <ul> tags and keep text inside them
        result = result.replace(/<ol>|<\/ol>/g, ''); // remove all <ol> tags and keep text inside them
        result = result.replace(/<li>(.*?)<\/li>/gi, '$1 '); // remove all <li> tags and keep text inside them
        result = result.replace(/<a[^>]*>(.*?)<\/a>/gi, '$1 '); // remove all <a> tags and text inside them
        result = result.replace(/<p>(.*?)<\/p>/g, '$1 '); // remove all <p> tags and keep text inside them
        result = result.replace(/<[^>]*>/g, ''); // remove all html tags
        result = result.replace(/&nbsp;/g, ' '); // remove all &nbsp; tags
        result = result.replace(/&lt;/g, '<'); // remove all &lt; tags
        result = result.replace(/&gt;/g, '>'); // remove all &gt; tags
        result = result.replace(/&quot;/g, '"'); // remove all &quot; tags
        result = result.replace(/&#39;/g, "'"); // replace all &#39; tags with '

        // replace all new lines with ' '
        result = result.replace(/(\r\n|\n|\r)/g, ' '); // remove all new lines

        // replace all multiple spaces with ' '
        result = result.replace(/\s+/g, ' '); // remove all multiple spaces

        return result.trim(); // remove all leading and trailing spaces
    }
}
